export default (
  state,
  { payload: { id: mergedId, variantId: purgedVariantId } }
) => {
  const items = state.items.filter(
    ({ id, variantId }) => variantId !== purgedVariantId || id === mergedId
  );

  return {
    ...state,
    displayableItemCount: items.length,
    items
  };
};
